module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step2_Image0.15ee2390.webp";